import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[450px] md:h-[600px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Elegant%20soft%20warm%20ambient%20lighting%20with%20delicate%20cherry%20blossom%20petals%20dancing%20in%20gentle%20breeze%2C%20dreamy%20romantic%20atmosphere%2C%20minimalist%20Japanese%20aesthetic%20with%20subtle%20golden%20and%20cream%20tones%2C%20blurred%20bokeh%20background%2C%20sophisticated%20editorial%20style%2C%20refined%20composition%20with%20warm%20candlelight%20glow&width=1600&height=900&seq=hero-yua-mikami&orientation=landscape"
        alt="三上悠亞官方粉絲頁"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
      <div className="relative z-10 text-center px-4 md:px-6 w-full max-w-3xl mx-auto">
        <p className="text-sm md:text-base text-white/80 font-medium tracking-widest mb-3 animate-fadeIn">
          OFFICIAL FAN PAGE
        </p>
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-4 tracking-wide animate-fadeIn">
          三上悠亞
        </h1>
        <p className="text-sm md:text-lg text-white/80 leading-relaxed max-w-xl mx-auto mb-8 animate-fadeIn">
          日本知名女演員與寫真偶像，匯集最新作品、個人資料、出道歷程及粉絲必知資訊，帶你全面了解三上悠亞的演藝世界與魅力所在
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 animate-fadeIn">
          <Link
            to="/category?tab=works"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-film-line"></i>
            探索作品
          </Link>
          <Link
            to="/about"
            className="inline-flex items-center gap-2 px-6 py-3 bg-background-50/20 text-white border border-white/30 rounded-full text-sm font-medium hover:bg-background-50/30 transition-all duration-300 whitespace-nowrap cursor-pointer backdrop-blur-sm"
          >
            <i className="ri-information-line"></i>
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}